import { createModuleBuilder } from '@evidentid/dashboard-commons/app';
import { GatewayApiClient } from '@evidentid/gateway-api-client';

import EvieRenameConversationProcedure from './procedures/EvieRenameConversationProcedure.vue';
import EvieChatView from './views/EvieChatView.vue';

export const evieAiModule = createModuleBuilder()
    .demandContext<{ gatewayClient: GatewayApiClient }>()
    .injectVue((app) => ({ $gatewayClient: app.gatewayClient }))
    .registerRoutes(() => [
        {
            path: '/:rpId/evie-chat/:conversationId?',
            name: 'evieChat',
            component: EvieChatView as any,
            meta: { title: 'Evie AI', whiteBackground: true },
        },
    ])
    .registerProcedures<{
    evieRenameConversationProcedure: { rpName: string, conversationId: string, currentTitle: string };
}>({
        evieRenameConversationProcedure: EvieRenameConversationProcedure as any,
    })
    .end();
